export default __webpack_public_path__ + "static/media/history_1970_03.1b52d475.png";